// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"113":"d52eeca5","165":"a6ad9269"}[chunkId] + ".chunk.js";
};